"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyQueue = void 0;
exports.reducer = reducer;
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const mutations_queue_1 = require("./mutations-queue");
exports.EmptyQueue = {
    queuedMutations: []
};
function reducer(state, action) {
    switch (action.type) {
        case "QueueMany": {
            let newState = state;
            for (const queueMutationDescription of action.queueMutationDescriptions) {
                newState = (0, mutations_queue_1.queueMutation)(queueMutationDescription, newState);
            }
            return newState;
        }
        case "Dequeue": {
            return (0, mutations_queue_1.dequeueMutation)(action.mutation, state);
        }
        case "DequeueMany": {
            let newState = state;
            for (const m of action.mutations) {
                newState = (0, mutations_queue_1.dequeueMutation)(m, newState);
            }
            return newState;
        }
        default: {
            (0, ts_exhaustive_check_1.exhaustiveCheck)(action);
            return state;
        }
    }
}
//# sourceMappingURL=mutations-queue-state.js.map